import "./Header.css"
// import gif from "../../Animation/home_csi_animation.gif"
import LogoIllustration from "./csi.logo.animation"
// import Three from "../../Animation/Three";
// import bgVideo from "./images/bgVideo.webm"

const Header = () => {
  return (
    <header className="header">
      <div className="overlay">
        <h1 className="homeHeading">
          Ideate, Innovate <span id="headingAnd">&</span> Learn
        </h1>
        <div className="headerTxt">
          "We cannot solve our problems with the same thinking we used when we
          created them."
        </div>
      </div>
      <div className="gif">
        <LogoIllustration />
        {/* <img src={gif} alt="gif" className="gif" /> */}
      </div>
    </header>
  )
}

export default Header
